
// Vega creates an SVG with a main <g> containing a transform translate.
// Get the y translation of the transform
export function getMarginTopFromVegaSVG(svgD3Selection) {
    var svgMargins = svgD3Selection.select('g').attr('transform');
    return parseInt(svgMargins.substring(svgMargins.lastIndexOf(',')+1, svgMargins.length-1)) || 0;
}